import { styled } from '@mui/material';
import Key from '../key';

export const StyledKey = styled(Key)(({ theme }) => ({
  padding: theme.spacing(1),
}));
